import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@vuepic/vue-datepicker/dist/main.css";
import "@/assets/styles/common.scss";
import Repository from "@/repository";

Repository.connector.setRefreshHandler(() => store.dispatch("auth/refreshSession"));
Repository.connector.setUnauthorizedHandler(() => {
  store.dispatch("auth/logout");
  if (router.currentRoute.value?.name !== "login") {
    router.replace({
      name: "login",
      query: { redirect: router.currentRoute.value?.fullPath || "/dashboard" },
    });
  }
});

createApp(App).use(store).use(router).mount("#app");
